import Mark from '../assets/images/MarkDefault.svg';

export const dataIndividual = [
	{
		icon: Mark,
		title: 'Personal Information',
		button: 'Continue',
		id: 'IPI',
		completed: 'INDIVIDUAL_LEVEL_1',
	},
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'IBI',
		completed: 'INDIVIDUAL_LEVEL_2',
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'IBA',
		completed: 'INDIVIDUAL_LEVEL_3',
	},
];

export const dataIndividualStageTwo = [
	{
		icon: Mark,
		title: 'Personal Information',
		button: 'Continue',
		id: 'IPI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'IBI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'IBA',
		completed: false,
	},
];

export const dataIndividualStageThree = [
	{
		icon: Mark,
		title: 'Personal Information',
		button: 'Continue',
		id: 'IPI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'IBI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'IBA',
		completed: true,
	},
];

export const dataBusiness = [
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'BBI',
		completed: 'BUSINESS_LEVEL_2',
	},
	{
		icon: Mark,
		title: 'Business Documents',
		button: 'Continue',
		id: 'BBD',
		completed: 'BUSINESS_LEVEL_3',
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'BAB',
		completed: 'BUSINESS_LEVEL_4',
	},
];

export const dataBusinessStageOne = [
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'BBI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Business Documents',
		button: 'Continue',
		id: 'BBD',
		completed: false,
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'BAB',
		completed: false,
	},
];

export const dataBusinessStageTwo = [
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'BBI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Business Documents',
		button: 'Continue',
		id: 'BBD',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'BAB',
		completed: false,
	},
];

export const dataBusinessStageThree = [
	{
		icon: Mark,
		title: 'Business Information',
		button: 'Continue',
		id: 'BBI',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Business Documents',
		button: 'Continue',
		id: 'BBD',
		completed: true,
	},
	{
		icon: Mark,
		title: 'Add Bank Account',
		button: 'Continue',
		id: 'BAB',
		completed: true,
	},
];
